<template>
  <button @click="handleClick">
    <b-icon-person-plus-fill title="Add" class="text-primary" />
  </button>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AddUserIcon',
  methods: {
    ...mapActions(['setActiveGroup']),
    handleClick: async function() {
      if (this.$route.path !== '/group/users') {
        // Reset active group so the group drop down doesn't autofocus
        await this.setActiveGroup()
      }
      this.$router.push('/user/add')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Icons/AddUserIcon.vue?5943d300